import { useMantineTheme } from "@mantine/core";
import { Fragment } from "react";
import { colors } from "theme";

import { useClientTranslation } from "hooks/useClientTranslation";

import { CORNER_POSITIONS, POINT_OF_IMPACT_TRANSLATION_KEYS } from "./constants";
import { usePointOfImpactList } from "./hooks/usePointOfImpactList";
import { useStyles } from "./styles";
import { PointOfImpact } from "./types";

export const ImpactSelectors = ({ editable = true }) => {
  const { classes } = useStyles({ editable });
  const { orderedList, setOrderedList } = usePointOfImpactList();
  const theme = useMantineTheme();
  const { t } = useClientTranslation();

  return (
    <>
      {Object.entries(CORNER_POSITIONS).map(([point, position]) => {
        const pointOfImpact = point as PointOfImpact;
        const selected = orderedList.includes(pointOfImpact);
        const fillColour = selected ? theme.other.primary[60] : colors.grey[30];
        const concatenatedPOI = pointOfImpact.replace(/\s/g, "");
        return (
          <Fragment key={concatenatedPOI}>
            <label
              htmlFor={`${concatenatedPOI}-option`}
              id={`${concatenatedPOI}-label`}
              className={classes.showOnlyToScreenReaders}
            >
              {t(POINT_OF_IMPACT_TRANSLATION_KEYS[pointOfImpact])}
            </label>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              role="checkbox"
              aria-checked={selected}
              onClick={() => editable && setOrderedList(pointOfImpact, !selected)}
              aria-labelledby={`${concatenatedPOI}-label`}
              xmlns="http://www.w3.org/2000/svg"
              className={classes.impactSelector}
              style={position}
            >
              <path
                d="M4.30012 9.65719L6.63783 12L4.30013 14.3428L5.01981 15.0625L8.08231 12L5.01981 8.9375L4.30012 9.65719Z"
                fill={fillColour}
              />
              <path
                d="M8.34456 8.98781L11.3502 12L8.34456 15.0122L9.26987 15.9375L13.2074 12L9.26987 8.0625L8.34456 8.98781Z"
                fill={fillColour}
              />
              <path
                d="M12.8487 7.98375L16.8562 12L12.8487 16.0163L14.0825 17.25L19.3325 12L14.0825 6.75L12.8487 7.98375Z"
                fill={fillColour}
              />
            </svg>
          </Fragment>
        );
      })}
    </>
  );
};
